export interface Category {
  slug: string;
  name: string;
  nameEn: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'southeast-asia',
    name: '东南亚',
    nameEn: 'Southeast Asia',
    description: '热带风情、古老寺庙与碧海蓝天，探索充满活力与神秘的东南亚诸国。',
    icon: 'ri-anchor-line',
  },
  {
    slug: 'east-asia',
    name: '东亚',
    nameEn: 'East Asia',
    description: '传统与现代交织，从千年古都到未来都市，感受东亚文化的独特魅力。',
    icon: 'ri-building-line',
  },
  {
    slug: 'south-asia',
    name: '南亚',
    nameEn: 'South Asia',
    description: '喜马拉雅山麓到印度洋岛屿，体验南亚的神秘宗教文化与壮丽自然风光。',
    icon: 'ri-landscape-line',
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find(c => c.slug === slug) || null;
};